// @flow

import React from "react";

import { ID_FONTE_FIDC_PADRAO, type MedidaSelecionada } from "../../../model";
import {
  type State,
  getExibirConfiguracoesAvancadas,
  getJanelaMovelSelecionada,
  analiseValorDaMedida,
} from "../../../state";

import SelecaoJanelaMovel from "../configuracoes/janela/SelecaoJanelaMovel";

export const processarSeriesComFonteEJanelaMovel = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

  return medidas.map(medida => {
    return {
      ...medida,
      fonteDeDadosFIDC: ID_FONTE_FIDC_PADRAO,
      janelaMovel: exibirConfiguracoesAvancadas
        ? getJanelaMovelSelecionada(state)
        : 1,
      ...analiseValorDaMedida(medida, state),
    };
  });
};

const SeriesComFonteEJanelaMovel = () => {
  return (
    <>
      <div className="ConfiguracaoMedida">
        <SelecaoJanelaMovel />
      </div>
    </>
  );
};

export default SeriesComFonteEJanelaMovel;
